// extracted by mini-css-extract-plugin
module.exports = {"ra-link":"ra-link_ra-link__svZD3","ra-link--remove-underline":"ra-link_ra-link--remove-underline__552Af"};